import * as tslib_1 from "tslib";
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseManagement } from '../../services/base-management';
import { interval } from 'rxjs';
import { DialogYesNoComponent } from '../dialog-yes-no/dialog-yes-no.component';
import { DialogOkComponent } from '../dialog-ok/dialog-ok.component';
export class TwoFactorVerificationModalComponent extends BaseManagement {
    constructor(fb, translate, route, router, dialogRef, data, authService) {
        super();
        this.fb = fb;
        this.translate = translate;
        this.route = route;
        this.router = router;
        this.dialogRef = dialogRef;
        this.data = data;
        this.authService = authService;
        this.countDown = 0;
        this.formattedTime = this.formatTime(this.countDown);
        this.showCountDownText = false;
        this.validatingCode = false;
        console.log(data);
        this.loginForm = this.fb.group({
            grant_type: ['password'],
            username: ['', Validators.compose([Validators.maxLength(70), Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'), Validators.required])],
            password: ['', Validators.required],
        });
    }
    ngOnInit() {
        this.initForm();
        if (this.data) {
            this.loginForm.patchValue(this.data);
        }
        else {
            this.dialogRef.close();
        }
    }
    ngOnDestroy() {
        this.clearSubscription();
    }
    ngAfterViewInit() {
        this.scrollToTargetDiv();
    }
    initForm() {
        this.twoFactorForm = this.fb.group({
            VerificationCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
        });
    }
    scrollToTargetDiv() {
        const targetDiv = document.getElementById('targetDiv');
        if (targetDiv) {
            targetDiv.scrollIntoView({ behavior: 'smooth' });
        }
    }
    resendCode() {
        this.clearSubscription();
        this.generateCode2FA();
    }
    formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return this.padZero(minutes) + ':' + this.padZero(remainingSeconds);
    }
    padZero(num) {
        return num < 10 ? '0' + num : num.toString();
    }
    clearSubscription() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    tryResendCode() {
        const dialogRef = this.dialog.open(DialogYesNoComponent, {
            width: '250px',
            data: {
                msg: '¿Reenviar Código de verificación?',
                yesText: 'Reenviar',
                noText: 'Cancelar',
            }
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 1) {
                this.countDown = 10;
                this.formattedTime = this.formatTime(this.countDown);
                this.resendCode();
            }
        });
    }
    validateCode() {
        this.validatingCode = true;
        this.verify2FAToken();
    }
    continueLogin() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.dialogRef.close(true);
        });
    }
    generateCode2FA() {
        // Genero codigo de dos factores
        this.authService.generateTwoFactor({ Email: this.loginForm.controls.username.value, Password: this.loginForm.controls.password.value }).then((response) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // console.log('generateTwoFactor', response);
            this.showCountDownText = true;
            this.countDown = 10;
            const timer$ = interval(1000);
            this.subscription = timer$.subscribe(() => {
                if (this.countDown > 0) {
                    this.countDown--;
                    this.formattedTime = this.formatTime(this.countDown);
                }
                else {
                    this.clearSubscription();
                }
            });
        }));
    }
    openDialogError() {
        const dialogRef = this.dialog.open(DialogOkComponent, {
            data: {
                msg: 'Código invalido. Intentelo de nuevo',
            }
        });
        dialogRef.afterClosed().subscribe((res) => { });
    }
    verify2FAToken() {
        // Verifico el token de dos factores
        this.authService.verifyTwoFactorToken({ Email: this.loginForm.controls.username.value, Token: this.twoFactorForm.controls.VerificationCode.value })
            .then((verify) => {
            if (verify.Success) {
                this.continueLogin();
            }
            else {
                this.validatingCode = false;
                this.openDialogError();
                console.error('verifyTwoFactorToken', verify);
            }
        })
            .catch((err) => {
            this.openDialogError();
            this.validatingCode = false;
        });
    }
}
